"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ChartComp;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _reactChartjs = require("react-chartjs-2");
require("chartjs-plugin-dragdata");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ChartComp(props) {
  const shouldRedraw = false;
  const [isLoaded, setIsLoaded] = (0, _react.useState)(false);

  //  Build Data Set for the Bar Chart
  const buildDataSet = data => {
    let labels = data.map(c => c.label);
    let options = {
      data: {
        labels: labels,
        datasets: [{
          label: 'Data',
          backgroundColor: data.map(c => c.color),
          data: data.map(c => c.value)
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            min: 0,
            max: 100
          }
        },
        onHover: function onHover(e) {
          const point = e.chart.getElementsAtEventForMode(e, 'nearest', {
            intersect: true
          }, false);
          if (point.length) e.native.target.style.cursor = 'grab';else e.native.target.style.cursor = 'default';
        },
        plugins: {
          dragData: {
            round: 1,
            showTooltip: true,
            onDragStart: function onDragStart(e, element) {},
            // Change while dragging 
            onDrag: function onDrag(e, datasetIndex, index, value) {
              e.target.style.cursor = 'grabbing';
            },
            // Only change when finished dragging 
            onDragEnd: function onDragEnd(e, datasetIndex, index, value) {
              e.target.style.cursor = 'default';
              if (datasetIndex == 0) {
                data[index].value = value;
              }
              console.log("Data for post :", data[index].label);
            }
          }
        }
      }
    };
    return options;
  };
  let localOption = buildDataSet(props.data);
  (0, _react.useEffect)(() => {
    setTimeout(() => {
      setIsLoaded(true);
    }, 200);
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", null, isLoaded && /*#__PURE__*/_react.default.createElement(_reactChartjs.Bar, {
    redraw: shouldRedraw,
    data: localOption.data,
    options: localOption.options,
    plugins: localOption.plugins
  }));
}